import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function SecurityCheckFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M13.166 1.53871C12.439 1.15376 11.5608 1.15376 10.8337 1.53871C9.63176 2.17509 7.16948 3.32075 4.21632 3.8341C3.12684 4.02349 2.24988 4.95478 2.24988 6.12325V11.0511C2.24988 14.5419 4.02951 17.2085 5.99201 19.0834C7.95193 20.9559 10.1519 22.0975 11.1533 22.5619C11.6941 22.8127 12.3056 22.8127 12.8465 22.5619C13.8479 22.0975 16.0478 20.9559 18.0077 19.0834C19.9702 17.2085 21.7499 14.5419 21.7499 11.0511V6.12325C21.7499 4.95478 20.8729 4.02349 19.7834 3.8341C16.8303 3.32075 14.368 2.17509 13.166 1.53871ZM16.7682 8.64021C17.1218 8.21593 17.0645 7.58537 16.6402 7.2318C16.2159 6.87824 15.5853 6.93556 15.2318 7.35984L10.9328 12.5186L9.20711 10.7929C8.81658 10.4024 8.18342 10.4024 7.79289 10.7929C7.40237 11.1834 7.40237 11.8166 7.79289 12.2071L10.2929 14.7071C10.4916 14.9058 10.7646 15.0117 11.0453 14.999C11.326 14.9863 11.5884 14.856 11.7682 14.6402L16.7682 8.64021Z"
				fill="currentColor"
			/>
		</svg>
	);
}

SecurityCheckFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default SecurityCheckFilledIcon;
